<template>
    <div class="te-cart__product">
        <div class="te-cart-product" v-if="productDefinition">
            <span class="te-cart-product__name">{{productDefinition.name}}</span>
            <span class="te-cart-product__remark" v-if="remark">{{remark}}</span>
        </div>
        <cart-item v-for="(cartItem, i) in cartItems"
                   v-bind:key="cartItem.id"
                   :name="cartItem.name"
                   :status="cartItem.status"
                   :currency="cartItem.currency"
                   :price="cartItem.price"
                   :quantity="cartItemQuantity(cartItem)"
                   :limit="cartItem.limit"
                   :tab-index="i"
                   :disable-cart-editing="disableCartEditing"
                   :language="language"
                   @change="onQuantityChange($event, cartItem)"
        >
        </cart-item>

    </div>
</template>

<script>
    import CartItem from './CartItem'

    export default {
        name: "CartProduct",

        components: {
            CartItem
        },

        props: {
            productDefinition: {
                type: Object,
                required: true
            },
            cartItems: {
                type: Array,
                required: true
            },
            orderId: {
                type: String,
                required: true
            },
            salesChannelId: {
                type: String,
                required: true
            },
            registerId: {
                type: String,
                required: true
            },
            customerId: {
                type: String
            },
            // editMode: {
            //     type: Boolean,
            //     default: false
            // },
            disableCartEditing: {
                type: Boolean,
                default: false
            },
            language: {
                type: Object
            },
        },

        computed: {
            remark: function() {
                // if(moment().isAfter(moment(this.event.end))) return this.languageSettings.eventAlreadyEnded;
                return null;
            },

            languageSettings: function() {
                const defaultSettings = {
                    productAlreadyEnded: 'Product already ended.',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            cartItemQuantity(cartItem) {
                if(cartItem && cartItem.lineItemIds) return cartItem.lineItemIds.length;
                return 0
            },

            onQuantityChange(quantity, cartItem) {
                const commands = [];
                if(cartItem.lineItemIds.length > quantity) {
                    // remove product from cart
                    const ac = cartItem.lineItemIds.length - quantity;
                    for (let i = 0; i < ac; i++) {
                        commands.push({
                            type: 'RemoveItemFromCart',
                            data: {
                                aggregateId: this.orderId,
                                orderLineItemId: cartItem.lineItemIds[i],
                            }
                        })
                    }
                } else if(cartItem.lineItemIds.length < quantity) {
                    // add product to cart
                    const ac = quantity - cartItem.lineItemIds.length;
                    for (let i = 0; i < ac; i++) {
                        commands.push({
                            type: 'AddProductToCart',
                            data: {
                                aggregateId: this.orderId,
                                productDefinitionId: cartItem.productDefinitionId,
                                requestedConditionPath: cartItem.requestedConditionPath,
                            }
                        })
                    }
                }
                this.$emit('change', {cartItemId: cartItem.id, commands: commands});
            }
        },
    }
</script>

<style scoped>

</style>
